import { makeStyles } from "@mui/styles";
import type { Theme } from "src/theme";

export const useSideMenuLayoutStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
        minWidth: "100vh",
        paddingTop: theme.constants.headerHeight,

        [theme.breakpoints.down(1280)]: {
            minHeight: `calc(100vh - 15px)`,
        },
    },

    content: {
        maxHeight: `calc(100vh - ${theme.constants.headerHeight}px)`,
        overflowY: "auto",

        [theme.breakpoints.down(1280)]: {
            maxHeight: `calc(100vh - ${theme.constants.headerHeight}px - 15px)`,
        },
    },

    withSection: {
        display: "flex",
    },

    menuContainer: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
    },

    menu: {
        position: "sticky",
        top: theme.spacing(5),
        maxHeight: "80vh",
        overflowY: "auto",
        minWidth: "250px",
    },

    contentContainer: {
        flex: "1",
    },
}));
